<template>
  <v-card class="mt-3 pa-3">
    <div class="d-flex justify-space-between align-center mb-3">
      <h4>{{ title }}</h4>
      <v-btn
        color="primary"
        small
        @click="addRow"
        style="background-color: #1976d2 !important; color: white !important;"
      >
        <v-icon left small style="color: white !important;">mdi-plus</v-icon>
        {{ addLabel }}
      </v-btn>
    </div>

    <v-data-table
      :headers="resolvedHeaders"
      :items="value"
      hide-default-footer
      class="elevation-0"
    >
      <template v-slot:[`item.obligation_type_id`]="{ item, index }">
        <v-text-field
          :value="item.obligation_type_id"
          type="text"
          hide-details
          dense
          outlined
          style="min-width: 200px"
          @input="updateField(index, 'obligation_type_id', $event)"
        ></v-text-field>
      </template>

      <template v-slot:[`item.installment`]="{ item, index }">
        <v-text-field
          :value="item.installment"
          type="number"
          hide-details
          dense
          outlined
          v-numericOnly
          style="min-width: 150px"
          @input="updateField(index, 'installment', $event)"
        ></v-text-field>
      </template>

      <template v-slot:[`item.remaining_amount`]="{ item, index }">
        <v-text-field
          :value="item.remaining_amount"
          type="number"
          hide-details
          dense
          outlined
          v-numericOnly
          style="min-width: 150px"
          @input="updateField(index, 'remaining_amount', $event)"
        ></v-text-field>
      </template>

      <template v-slot:[`item.actions`]="{ index }">
        <v-btn icon small color="error" @click="removeRow(index)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-divider class="mt-3"></v-divider>
    <div class="d-flex justify-space-between align-center mt-3">
      <h4>{{ totalLabel }}</h4>
      <h4>{{ totalRemainingAmount.toLocaleString() }} {{ currencyLabel }}</h4>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "ObligationsTable",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: "الالتزامات",
    },
    addLabel: {
      type: String,
      default: "إضافة التزام",
    },
    totalLabel: {
      type: String,
      default: "المجموع:",
    },
    currencyLabel: {
      type: String,
      default: "ريال",
    },
    emptyRow: {
      type: Object,
      default: () => ({
        id: null,
        obligation_type_id: null,
        installment: 0,
        remaining_amount: 0,
      }),
    },
  },
  computed: {
    resolvedHeaders() {
      return (
        this.headers || [
          { text: "نوع الالتزام", value: "obligation_type_id", sortable: false },
          { text: "القسط", value: "installment", sortable: false },
          { text: "المبلغ المتبقي", value: "remaining_amount", sortable: false },
          { text: "العمليات", value: "actions", sortable: false },
        ]
      );
    },
    totalRemainingAmount() {
      return (this.value || []).reduce((sum, item) => {
        return sum + (parseFloat(item && item.remaining_amount) || 0);
      }, 0);
    },
  },
  methods: {
    emitValue(next) {
      this.$emit("input", next);
    },
    addRow() {
      const next = [...(this.value || []), { ...this.emptyRow }];
      this.emitValue(next);
    },
    removeRow(index) {
      const arr = this.value || [];
      const next = arr.filter((_, i) => i !== index);
      this.emitValue(next);
    },
    updateField(index, key, val) {
      const arr = this.value || [];
      const next = arr.map((row, i) => {
        if (i !== index) return row;
        return { ...(row || {}), [key]: val };
      });
      this.emitValue(next);
    },
  },
};
</script>

